let universalCloseButtonBound = false;

export function bindUniversalCloseButton() {
  if (universalCloseButtonBound) return;
  universalCloseButtonBound = true;

  document.addEventListener('mouseup', (event) => {
    const closeLink = event.target.closest('a.close');
    if (!closeLink) return;

    const parent = closeLink.parentElement;
    if (parent) parent.remove();
  });
}
